module.exports = __webpack_public_path__ + "static/img/02450_8.2560466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_8.jpg
// module id = KhGu
// module chunks = 1